import { supabase } from '../lib/supabase';

/**
 * Fetches the app configuration from the database
 * @param {string} key - The configuration key to fetch
 * @returns {Promise<Object>} - The configuration value
 */
export const getAppConfig = async (key) => {
  try {
    const { data, error } = await supabase
      .from('app_config')
      .select('value')
      .eq('key', key)
      .single();

    if (error) {
      console.error(`Error fetching ${key} config:`, error);
      return null;
    }

    return data?.value || null;
  } catch (error) {
    console.error(`Failed to fetch ${key} config:`, error);
    return null;
  }
};

/**
 * Fetches the order options configuration
 * @returns {Promise<Object>} - The order options configuration
 */
export const getOrderOptions = async () => {
  const defaultConfig = {
    burger: {
      pickup_enabled: true,
      delivery_enabled: true
    },
    pizza: {
      pickup_enabled: true,
      delivery_enabled: true
    }
  };

  try {
    const config = await getAppConfig('order_options');
    return config || defaultConfig;
  } catch (error) {
    console.error('Failed to fetch order options:', error);
    return defaultConfig;
  }
};

/**
 * Updates the app configuration in the database
 * @param {string} key - The configuration key to update
 * @param {Object} value - The new configuration value
 * @returns {Promise<boolean>} - True if successful
 */
export const updateAppConfig = async (key, value) => {
  try {
    const { error } = await supabase
      .from('app_config')
      .update({ 
        value,
        updated_at: new Date().toISOString()
      })
      .eq('key', key);

    if (error) {
      console.error(`Error updating ${key} config:`, error);
      return false;
    }

    return true;
  } catch (error) {
    console.error(`Failed to update ${key} config:`, error);
    return false;
  }
};